var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInputError = function SvgInputError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00014 6.42566C8.55303 6.42566 8.23511 6.61445 8.23511 6.89264V10.678C8.23511 10.9165 8.55306 11.1549 9.00014 11.1549C9.42736 11.1549 9.77509 10.9165 9.77509 10.678V6.89264C9.77509 6.61445 9.42736 6.42566 9.00014 6.42566Z",
    fill: "#FF5B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00014 4.09082C8.5431 4.09082 8.18542 4.41869 8.18542 4.79623C8.18542 5.17377 8.5431 5.51159 9.00014 5.51159C9.44725 5.51159 9.80493 5.17377 9.80493 4.79623C9.80493 4.41872 9.44722 4.09082 9.00014 4.09082Z",
    fill: "#FF5B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.72493 0 1.26562 3.45755 1.26562 7.72991C1.26562 11.2185 3.56249 14.1152 6.65919 15.099L8.41813 17.6916C8.54898 17.8845 8.76691 18 9 18C9.23309 18 9.45102 17.8845 9.58187 17.6916L11.3408 15.099C14.4389 14.1147 16.7344 11.217 16.7344 7.72991C16.7344 3.45484 13.2723 0 9 0ZM10.7102 13.8199C10.55 13.8647 10.411 13.9647 10.3177 14.1023L9 16.0445L7.68238 14.1023C7.589 13.9648 7.44996 13.8647 7.28982 13.8199C4.65388 13.0829 2.67188 10.6587 2.67188 7.72991C2.67188 4.24301 5.51067 1.40625 9 1.40625C12.4893 1.40625 15.3281 4.24301 15.3281 7.72991C15.3281 10.6616 13.3432 13.0837 10.7102 13.8199Z",
    fill: "#FF5B5B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInputError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/input-error.070b174f.svg";
export { ForwardRef as ReactComponent };